
import { defineComponent, ref, shallowRef } from "vue";

import AMapLoader from "@amap/amap-jsapi-loader";

export default defineComponent({
    setup() {
        const map = shallowRef(null);
        const load = ref(false);
        return {
            map,
            AMap: null,
            load
        };
    },
    props: {
        mapConfig: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    created() {
        this.initMap();
    },
    methods: {
        /**
         * 初始化地图，包着地图的容器一定一定要有宽高，不然会报错，不知道为什么
         */
        initMap() {
            AMapLoader.load({
                key: "dcdce9fa9b7903f656c7d6c1b9e3c9bf", // 申请好的Web端开发者Key，首次调用 load 时必填
                version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
                plugins: [""], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
            })
                .then(async (AMap) => {
                    this.AMap = AMap;
                    this.map = new AMap.Map("container", {
                        ...this.mapConfig,
                    });

                    this.$emit('initMap', { map: this.map, AMap })

                    const _this = this;
                    this.map.on("complete", function () {
                        _this.$emit('mapComplete', { map: this.map, AMap })
                    });

                })
                .catch((e) => {
                    console.log(e);
                });
        },


    },
});
